import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';

const FilterTag = ({ name, onClick, className }) => (
	<div
		className={`filterTag ${className || ''}`}
		data-testid='filter-tag'
	>
		<span className='text-body-2 flex items-center gap-x-1 bg-neutral-50 py-2 pl-2 pr-4 font-semibold text-black'>
			<button
				aria-label='Close'
				className='cursor-pointer leading-none'
				onClick={onClick}
			>
				<Icon
					name='close'
					className='block'
					size={20}
					weight={600}
				/>
			</button>

			{name}
		</span>
	</div>
);

FilterTag.propTypes = {
	name: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default FilterTag;
